import React, { useState } from 'react';
import CrackScreen from './CrackScreen';
import CrackScreen2 from './CrackScreen2';
import CrackScreen3 from './CrackScreen3';
import Layers from './Layers';

interface MDFScreensProps {
    selectedCrackScreen: string | null;
    setSelectedCrackScreen: React.Dispatch<React.SetStateAction<string | null>>;
}
const MDFScreens: React.FC<MDFScreensProps> = ({selectedCrackScreen, setSelectedCrackScreen}) => {
  const [selectedLayers, setSelectedLayers] = useState<string[]>(["Overview"]);
  return (
<>
<Layers setSelectedCrackScreen={setSelectedCrackScreen} selectedLayers={selectedLayers} setSelectedLayers={setSelectedLayers}/>
{selectedCrackScreen === "Crac-1" && (
<CrackScreen selectedLayers={selectedLayers}/>

)} 
{selectedCrackScreen === "Crac-2" && (
<CrackScreen2 selectedLayers={selectedLayers}/>

)} 
{selectedCrackScreen === "Crac-3" && (
<CrackScreen3 selectedLayers={selectedLayers}/>

)} 
</>  );
};

export default MDFScreens;